// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Style-for-innovation-page*/
img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

/*Variables*/
::ng-deep .sky-bg {
  background-color: #00aed9;
}

::ng-deep .sky-light-bg {
  background-color: #e2f3fa;
}

::ng-deep .orange-bg {
  background-color: #f68c1f;
}

::ng-deep .orange-light-bg {
  background-color: #fdf1e1;
}

::ng-deep .develop-bg {
  background-color: #66bd4a;
}

::ng-deep .develop-light-bg {
  background-color: #eef6ea;
}

::ng-deep .implement-bg {
  background-color: #ef465b;
}

::ng-deep .notes-bg {
  background-color: #6e6d72;
}

/* Common-classes*/
::ng-deep .all-toolcards ::ng-deep.innovation-section {
  font-family: "Museo-regular";
  max-width: 960px;
  width: 90%;
  margin: 20px auto 30px;
  background: #fefefe;
  overflow: hidden;
  /* use-custom-classes for various section with same style*/
  /* Orange-color*/
  /* Develop*/
  /* Implement*/
  /* Notes */
  /* Welcome-section*/
}
@media only screen and (max-width: 767px) {
  ::ng-deep .all-toolcards ::ng-deep.innovation-section {
    width: 100%;
  }
}
::ng-deep .all-toolcards ::ng-deep.innovation-section p {
  color: #8a8a8a;
  font-family: "Museo-100";
}
::ng-deep .all-toolcards ::ng-deep.innovation-section li {
  font-family: "Museo-100";
}
::ng-deep .all-toolcards ::ng-deep.innovation-section .section-top {
  overflow: hidden;
  padding: 30px 60px;
}
@media only screen and (max-width: 991px) {
  ::ng-deep .all-toolcards ::ng-deep.innovation-section .section-top {
    padding: 30px;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep .all-toolcards ::ng-deep.innovation-section .section-top {
    padding: 20px;
  }
}
::ng-deep .all-toolcards ::ng-deep.innovation-section .section-top .top-heading {
  color: #fff;
}
::ng-deep .all-toolcards ::ng-deep.innovation-section .section-top .sub-heading {
  color: #fff !important;
  margin: 0px;
}
::ng-deep .all-toolcards ::ng-deep.innovation-section .top-heading {
  font-family: "Museo-regular";
  font-size: 50px;
  text-transform: capitalize;
  line-height: 52px;
  margin-top: 0px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep .all-toolcards ::ng-deep.innovation-section .top-heading {
    font-size: 36px;
  }
}
::ng-deep .all-toolcards ::ng-deep.innovation-section .sub-heading {
  font-family: "Museo-regular";
  font-size: 24px;
  line-height: 30px;
  margin: 0;
}
@media only screen and (max-width: 767px) {
  ::ng-deep .all-toolcards ::ng-deep.innovation-section .sub-heading {
    font-size: 20px;
  }
}
::ng-deep .all-toolcards ::ng-deep.innovation-section .shaded-part {
  padding: 30px 60px;
}
@media only screen and (max-width: 991px) {
  ::ng-deep .all-toolcards ::ng-deep.innovation-section .shaded-part {
    padding: 30px;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep .all-toolcards ::ng-deep.innovation-section .shaded-part {
    padding: 20px;
  }
}
::ng-deep .all-toolcards ::ng-deep.innovation-section .content-part {
  padding: 30px 60px 30px;
  margin-bottom: 35px;
}
@media only screen and (max-width: 991px) {
  ::ng-deep .all-toolcards ::ng-deep.innovation-section .content-part {
    padding: 30px;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep .all-toolcards ::ng-deep.innovation-section .content-part {
    padding: 20px;
  }
}
::ng-deep .all-toolcards ::ng-deep.innovation-section .content-part textarea.no-brdr {
  border: none;
  min-height: 200px;
  background-image: none;
}
::ng-deep .all-toolcards ::ng-deep.innovation-section textarea {
  width: 100%;
  border: none;
  min-height: 60px;
  padding: 10px 5px;
  background-color: #f1f3fe;
  background-position: center center;
  background-size: 8px 1px;
  background-repeat: repeat-x;
  outline: none;
  margin-bottom: 15px;
}
::ng-deep .all-toolcards ::ng-deep.innovation-section textarea:focus {
  background-color: #fff;
}
::ng-deep .all-toolcards ::ng-deep.innovation-section form.input-form {
  padding: 2px;
  margin-bottom: 15px;
}
::ng-deep .all-toolcards ::ng-deep.innovation-section form.input-form label {
  margin: 0px;
}
::ng-deep .all-toolcards ::ng-deep.innovation-section form.input-form input {
  background-color: #f1f3fe;
  border: none;
  outline: none;
  padding: 5px 0px;
}
::ng-deep .all-toolcards ::ng-deep.innovation-section form.input-form input:focus {
  background-color: transparent;
}
::ng-deep .all-toolcards ::ng-deep.innovation-section .clr {
  margin-bottom: 30px;
}
::ng-deep .all-toolcards ::ng-deep.innovation-section .innovation-footer {
  text-align: center;
  padding: 15px 0px;
}
::ng-deep .all-toolcards ::ng-deep.innovation-section .innovation-footer p {
  font-size: 10px;
  color: #333;
  margin: 0px;
}
::ng-deep .all-toolcards ::ng-deep.innovation-section.clarify .sub-heading {
  color: #00aed9;
}
::ng-deep .all-toolcards ::ng-deep.innovation-section.clarify textarea {
  border: 1px solid #00aed9;
  background-image: linear-gradient(to left, #00aed9 33%, rgba(255, 255, 255, 0) 0%);
}
::ng-deep .all-toolcards ::ng-deep.innovation-section.clarify form.input-form {
  border: 2px solid #00aed9;
}
::ng-deep .all-toolcards ::ng-deep.innovation-section.clarify form.input-form .input-tabs {
  background-image: linear-gradient(to left, #00aed9 33%, rgba(255, 255, 255, 0) 0%);
  background-position: bottom;
  background-size: 8px 1px;
  background-repeat: repeat-x;
  padding: 1px;
  display: flex;
  flex-wrap: wrap;
}
::ng-deep .all-toolcards ::ng-deep.innovation-section.clarify form.input-form .input-tabs:last-child {
  background: none;
}
::ng-deep .all-toolcards ::ng-deep.innovation-section.clarify form.input-form .input-tabs input {
  flex-grow: 1;
}
::ng-deep .all-toolcards ::ng-deep.innovation-section.clarify form.input-form label {
  color: #00aed9;
  min-width: 18px;
}
::ng-deep .all-toolcards ::ng-deep.innovation-section.clarify .clr {
  color: #00aed9;
}
::ng-deep .all-toolcards ::ng-deep.innovation-section.ideate .sub-heading {
  color: #f68c1f;
}
::ng-deep .all-toolcards ::ng-deep.innovation-section.ideate textarea {
  border: 1px solid #f68c1f;
  background-image: linear-gradient(to left, #f68c1f 33%, rgba(255, 255, 255, 0) 0%);
}
::ng-deep .all-toolcards ::ng-deep.innovation-section.ideate form.input-form {
  border: 2px solid #f68c1f;
  overflow: hidden;
}
::ng-deep .all-toolcards ::ng-deep.innovation-section.ideate form.input-form .input-tabs {
  background-image: linear-gradient(to left, #f68c1f 33%, rgba(255, 255, 255, 0) 0%);
  background-position: bottom;
  background-size: 8px 1px;
  background-repeat: repeat-x;
  padding: 1px;
  width: 50%;
  float: left;
}
@media only screen and (max-width: 767px) {
  ::ng-deep .all-toolcards ::ng-deep.innovation-section.ideate form.input-form .input-tabs {
    width: 100%;
  }
}
::ng-deep .all-toolcards ::ng-deep.innovation-section.ideate form.input-form .input-tabs:last-child {
  background: none;
}
::ng-deep .all-toolcards ::ng-deep.innovation-section.ideate form.input-form .input-tabs input {
  width: calc(100% - 22px);
}
::ng-deep .all-toolcards ::ng-deep.innovation-section.ideate form.input-form .input-tabs:nth-child(even) {
  background-image: linear-gradient(to left, #f68c1f 33%, rgba(255, 255, 255, 0) 0%), linear-gradient(#f68c1f 33%, rgba(255, 255, 255, 0) 0%);
  background-position: bottom, left;
  background-size: 8px 1px, 1px 8px;
  background-repeat: repeat-x, repeat-y;
  padding-left: 5px;
}
::ng-deep .all-toolcards ::ng-deep.innovation-section.ideate form.input-form label {
  color: #f68c1f;
  width: 18px;
}
::ng-deep .all-toolcards ::ng-deep.innovation-section.ideate .clr {
  color: #f68c1f;
}
::ng-deep .all-toolcards ::ng-deep.innovation-section.develop .sub-heading, ::ng-deep .all-toolcards ::ng-deep.innovation-section.develop .develop-color {
  color: #66bd4a;
}
::ng-deep .all-toolcards ::ng-deep.innovation-section.develop textarea {
  border: 1px solid #66bd4a;
  background-image: linear-gradient(to left, #66bd4a 20%, rgba(255, 255, 255, 0) 0%);
}
::ng-deep .all-toolcards ::ng-deep.innovation-section.develop textarea.line-text {
  background: #fff;
  background: linear-gradient(to bottom, #66bd4a 0%, #fff 2%) 0 -8px;
  -webkit-background-size: 100% 35px;
}
::ng-deep .all-toolcards ::ng-deep.innovation-section.develop strong {
  color: #66bd4a;
  font-size: 110%;
}
::ng-deep .all-toolcards ::ng-deep.innovation-section.develop .point-evaluation {
  padding: 0px;
  border: 1.5px solid #66bd4a;
  margin-bottom: 20px;
}
::ng-deep .all-toolcards ::ng-deep.innovation-section.develop .point-evaluation .f-col-4 {
  padding: 0;
  color: #66bd4a;
  font-family: "Museo-regular";
}
@media only screen and (min-width: 768px) {
  ::ng-deep .all-toolcards ::ng-deep.innovation-section.develop .point-evaluation .f-col-4 {
    border-right: 1.5px solid #66bd4a;
  }
}
::ng-deep .all-toolcards ::ng-deep.innovation-section.develop .point-evaluation .f-col-4:last-child {
  border-right: 0;
}
::ng-deep .all-toolcards ::ng-deep.innovation-section.develop .point-evaluation .f-col-4 h4 {
  font-size: 18px;
  margin: 0px;
  padding: 15px 15px 13px 50px;
  position: relative;
  font-family: "Museo-regular";
  border-bottom: 1px solid;
}
@media only screen and (max-width: 767px) {
  ::ng-deep .all-toolcards ::ng-deep.innovation-section.develop .point-evaluation .f-col-4 h4 {
    padding: 15px 15px 13px 40px;
  }
}
::ng-deep .all-toolcards ::ng-deep.innovation-section.develop .point-evaluation .f-col-4 h4 small {
  clear: both;
  display: block;
  font-family: "Museo-regular";
  line-height: 1.4em;
  margin-top: 4px;
  color: inherit;
}
::ng-deep .all-toolcards ::ng-deep.innovation-section.develop .point-evaluation .f-col-4 h4:before {
  content: "P";
  background: #66bd4a;
  color: #fff;
  font-size: 20px;
  height: 35px;
  width: 35px;
  position: absolute;
  border-radius: 17.5px;
  font-family: "Museo-regular";
  text-align: center;
  vertical-align: middle;
  padding-top: 7px;
  margin-left: -42px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep .all-toolcards ::ng-deep.innovation-section.develop .point-evaluation .f-col-4 h4:before {
    font-size: 13px;
    height: 20px;
    width: 25px;
    margin-left: -35px;
  }
}
::ng-deep .all-toolcards ::ng-deep.innovation-section.develop .point-evaluation .f-col-4 h4.middle-header:before {
  content: "O";
}
::ng-deep .all-toolcards ::ng-deep.innovation-section.develop .point-evaluation .f-col-4.issues h4:before {
  content: "I";
}
::ng-deep .all-toolcards ::ng-deep.innovation-section.develop .point-evaluation .f-col-4.new-thinking h4:before {
  content: "Nt";
}
::ng-deep .all-toolcards ::ng-deep.innovation-section.develop .point-evaluation .f-col-4 .middle-header {
  border-top: 1px solid;
}
::ng-deep .all-toolcards ::ng-deep.innovation-section.develop .point-evaluation .f-col-4 .fill-text {
  border-bottom: 1px dashed;
  padding: 15px;
  position: relative;
}
::ng-deep .all-toolcards ::ng-deep.innovation-section.develop .point-evaluation .f-col-4 .fill-input {
  border-bottom: 1px dashed;
  padding: 1px;
}
::ng-deep .all-toolcards ::ng-deep.innovation-section.develop .point-evaluation .f-col-4 .fill-input label {
  min-width: 20px;
  line-height: 40px;
  text-align: center;
  margin: 0;
}
::ng-deep .all-toolcards ::ng-deep.innovation-section.develop .point-evaluation .f-col-4 .fill-input input {
  border: none;
  outline: none;
  min-height: 42px;
  background: #f1f3fe;
  width: calc(100% - 24px);
}
::ng-deep .all-toolcards ::ng-deep.innovation-section.develop .point-evaluation .f-col-4 .fill-input input:focus {
  background: #fff;
}
::ng-deep .all-toolcards ::ng-deep.innovation-section.develop .point-evaluation .f-col-4 .fill-input:last-child {
  border: none;
}
::ng-deep .all-toolcards ::ng-deep.innovation-section.develop .point-evaluation .f-col-4 .fill-input.mid label {
  line-height: 20px;
}
::ng-deep .all-toolcards ::ng-deep.innovation-section.develop .point-evaluation .f-col-4 .fill-input.mid input {
  width: 100%;
}
::ng-deep .all-toolcards ::ng-deep.innovation-section.develop .point-evaluation .f-col-4 .fill-input.mid textarea {
  min-height: 69px;
  margin: 0px;
  border-bottom: 1px dashed #66bd4a;
}
::ng-deep .all-toolcards ::ng-deep.innovation-section.develop .point-evaluation .f-col-4 .fill-input.mid.last {
  border: none !important;
  height: 100%;
  overflow: hidden;
}
::ng-deep .all-toolcards ::ng-deep.innovation-section.develop .point-evaluation .f-col-4 .fill-input.mid.last textarea {
  height: 100%;
}
::ng-deep .all-toolcards ::ng-deep.innovation-section.develop .point-evaluation .f-col-4.pluses .fill-input:nth-of-type(3) {
  border-bottom: none !important;
}
::ng-deep .all-toolcards ::ng-deep.innovation-section.develop .point-evaluation .f-col-4 .fill-bottom {
  position: absolute;
  bottom: 10px;
  left: 0;
  right: 0;
  text-align: center;
}
::ng-deep .all-toolcards ::ng-deep.innovation-section.develop .point-evaluation .f-col-4 .fill-text:last-child, ::ng-deep .all-toolcards ::ng-deep.innovation-section.develop .point-evaluation .f-col-4 .last-cell {
  border-bottom: none;
}
::ng-deep .all-toolcards ::ng-deep.innovation-section.develop .point-evaluation .f-col-4 .fill-wrapper {
  display: flex;
  flex-direction: column;
  height: 364px;
}
::ng-deep .all-toolcards ::ng-deep.innovation-section.develop .point-evaluation .f-col-4 .fill-wrapper .fill-text {
  flex: 1;
}
::ng-deep .all-toolcards ::ng-deep.innovation-section.develop .point-evaluation .col-sm-4:last-child {
  border-right: none;
}
::ng-deep .all-toolcards ::ng-deep.innovation-section.develop .clr {
  color: #66bd4a;
}
::ng-deep .all-toolcards ::ng-deep.innovation-section.develop .shaded-part.footer-page {
  padding-top: 0px !important;
}
::ng-deep .all-toolcards ::ng-deep.innovation-section.implement .sub-heading {
  color: #ef465b;
}
::ng-deep .all-toolcards ::ng-deep.innovation-section.implement .clr {
  color: #ef465b;
}
::ng-deep .all-toolcards ::ng-deep.innovation-section.implement .implement-color {
  color: #ef465b;
}
::ng-deep .all-toolcards ::ng-deep.innovation-section.implement h4 {
  font-size: 18px;
  font-family: "Museo-regular";
}
::ng-deep .all-toolcards ::ng-deep.innovation-section.implement ul {
  padding-left: 15px;
}
::ng-deep .all-toolcards ::ng-deep.innovation-section.implement textarea {
  border: 1px solid #ef465b;
  background-image: linear-gradient(to left, #ef465b 20%, rgba(255, 255, 255, 0) 0%);
}
::ng-deep .all-toolcards ::ng-deep.innovation-section.implement .to-do {
  padding: 0px;
  border: 1px solid #ef465b;
  margin-bottom: 15px;
}
::ng-deep .all-toolcards ::ng-deep.innovation-section.implement .to-do .col-sm-6 {
  padding: 0px;
}
::ng-deep .all-toolcards ::ng-deep.innovation-section.implement .to-do .col-sm-6 input {
  width: calc(100% - 18px) !important;
}
::ng-deep .all-toolcards ::ng-deep.innovation-section.implement .to-do .col-sm-2 {
  padding: 0px;
  border-left: 1px dotted #ef465b;
}
::ng-deep .all-toolcards ::ng-deep.innovation-section.implement .to-do .to-do-heading {
  color: #ef465b;
  padding: 5px 10px;
}
::ng-deep .all-toolcards ::ng-deep.innovation-section.implement .to-do .to-do-term {
  background-color: #ef465b;
  min-height: 30px;
}
::ng-deep .all-toolcards ::ng-deep.innovation-section.implement .to-do .to-do-term p {
  color: #fff;
  margin: 0px;
  padding-left: 10px;
  line-height: 30px;
}
::ng-deep .all-toolcards ::ng-deep.innovation-section.implement .to-do .to-do-input {
  min-height: 42px;
  padding: 2px;
}
::ng-deep .all-toolcards ::ng-deep.innovation-section.implement .to-do .to-do-input label {
  color: #ef465b;
  width: 12px;
  font-weight: 100;
}
::ng-deep .all-toolcards ::ng-deep.innovation-section.implement .to-do .to-do-input input {
  outline: none;
  background: #f1f3fe;
  min-height: 40px;
  width: 100%;
  border: none;
}
::ng-deep .all-toolcards ::ng-deep.innovation-section.implement .to-do .to-do-input input:focus {
  background: #fff;
}
::ng-deep .all-toolcards ::ng-deep.innovation-section.notes .content-part textarea {
  min-height: 800px;
}
::ng-deep .all-toolcards ::ng-deep.innovation-section.welcome {
  background: #e7e7e7;
}
::ng-deep .all-toolcards ::ng-deep.innovation-section.welcome .top-heading img {
  max-width: 300px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep .all-toolcards ::ng-deep.innovation-section.welcome .top-heading img {
    max-width: 100%;
  }
}
::ng-deep .all-toolcards ::ng-deep.innovation-section.welcome .shaded-part {
  text-align: center;
}
::ng-deep .all-toolcards ::ng-deep.innovation-section.welcome .shaded-part span {
  font-size: 20px;
  font-weight: 100;
}
@media only screen and (max-width: 767px) {
  ::ng-deep .all-toolcards ::ng-deep.innovation-section.welcome .shaded-part span {
    font-size: 16px;
  }
}
::ng-deep .all-toolcards ::ng-deep.innovation-section.welcome .content-part p, ::ng-deep .all-toolcards ::ng-deep.innovation-section.welcome .content-part ul {
  font-size: 18px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep .all-toolcards ::ng-deep.innovation-section.welcome .content-part ul {
    padding-left: 22px;
  }
}

::ng-deep ul.nav-wizard {
  background-color: #f9f9f9;
  border: 1px solid #d4d4d4;
  border-radius: 6px;
  position: relative;
  overflow: hidden;
  display: table;
  float: none;
  margin-left: auto;
  margin-right: auto;
  max-width: 960px;
}

/* Eos-Section-Style*/
.all-toolcards .eos {
  font-family: "Museo-regular";
  max-width: 960px;
  width: 90%;
  margin: 20px auto 30px;
  background: #fefefe;
  overflow: hidden;
  border: 1px solid #aaa;
}
.all-toolcards .eos ul {
  padding-left: 15px;
}
.all-toolcards .eos .row { /* OLD - iOS 6-, Safari 3.1-6 */
  /* OLD - Firefox 19- (buggy but mostly works) */ /* TWEENER - IE 10 */
  display: -webkit-flex;
  padding: 1px;
  flex-wrap: wrap;
}
.all-toolcards .eos .eos-right {
  padding: 0px;
}
.all-toolcards .eos .eos-heading {
  border: 1px solid #aaa;
  align-items: center;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  background: #fafafb;
  color: #706a6c;
  border-left: 3px solid #1ab394;
  padding: 8px 0px;
}
.all-toolcards .eos .eos-heading:hover {
  cursor: pointer;
}
.all-toolcards .eos .eos-heading h4 {
  text-transform: uppercase;
  font-size: 18px;
  font-family: "Museo-regular";
}
.all-toolcards .eos .eos-heading h4 sup {
  font-family: arial;
}
.all-toolcards .eos .eos-content {
  border: 1px solid #aaa;
  padding: 11px 15px;
}
.all-toolcards .eos .eos-right-content {
  border: 1px solid #aaa;
  padding: 13px 15px 0;
}
.all-toolcards .eos .eos-input {
  display: flex;
  border-bottom: 1px dotted;
  padding: 1px;
}
.all-toolcards .eos .eos-input label {
  margin: 0px;
  line-height: 30px;
}
.all-toolcards .eos .eos-input input {
  flex-grow: 1;
  border: none;
  outline: none;
  background: #f1f3fe;
  min-height: 30px;
}
.all-toolcards .eos .eos-input input:focus {
  background: #fff;
}
.all-toolcards .eos .eos-input:last-child {
  border: none;
}

::ng-deep .audio-modal a, ::ng-deep .audio-modal p {
  display: none;
}

::ng-deep .audio-modal .showText {
  display: block;
}

::ng-deep.grey {
  background: rgba(236, 236, 236, 0.9);
}`, "",{"version":3,"sources":["webpack://./src/app/components/innovation-station/innovation-station.component.scss","webpack://./src/assets/styles/_variables.scss"],"names":[],"mappings":"AAAA,6BAAA;ACgIA;EACE,eAAA;AD9HF;;ACiIA;EACE,aAAA;EACA,eAAA;AD9HF;;ACiIA;EACE,sBAAA;AD9HF;;ACiIA;EACE,8BAAA;AD9HF;;ACiIA;EACE,gBAAA;AD9HF;;ACiIA;EACE,gBAAA;AD9HF;;ACiIA;EACE,aAAA;AD9HF;;ACiIA;EACE,gBAAA;AD9HF;;AC4IE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;ADzIJ;AC2II;;;;;;EACE,gBAAA;ADpIN;ACwIE;;EAEE,eA5GO;EA6GP,gBA3GO;AD3BX;ACwII;EALF;;IAMI,eA/GY;EDrBhB;AACF;ACuIE;;EAEE,eAlHO;EAmHP,gBAjHO;ADpBX;ACuII;EALF;;IAMI,eArHY;EDdhB;AACF;ACsIE;;EAEE,eAxHO;EAyHP,gBAvHO;ADbX;ACsII;EALF;;IAMI,eA3HY;EDPhB;AACF;ACqIE;;EAEE,eA9HO;EA+HP,gBA7HO;ADNX;ACsIE;;EAEE,eAhIO;EAiIP,gBAhIO;ADJX;ACuIE;;EAEE,eAnIO;EAoIP,gBAnIO;ADFX;AC2IE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;ADzIJ;AC2II;EACE,gBAAA;ADzIN;AC4II;EAXF;IAYI,eAAA;EDzIJ;AACF;AC4IE;;EAEE,UAAA;EACA,SAAA;AD1IJ;AC6IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;AD3IJ;;AC+IA;EACE,sBAxNQ;AD4EV;;AC+IA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AD5IF;AC8IE;EALF;IAMI,cAAA;ED3IF;AACF;AC6IE;EACE,iBA1Ka;AD+BjB;AC8IE;EACE,gBApLa;EAqLb,WAAA;AD5IJ;;ACiJE;EACE,kBAAA;AD9IJ;ACiJE;EACE,iBAAA;AD/IJ;;ACoJE;EACE,aAAA;ADjJJ;;ACqJA;EACE,kBAAA;ADlJF;ACoJE;EACE,mBAAA;ADlJJ;ACsJI;EACE,sBAAA;ADpJN;ACwJE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ADwEnB;ACwJI;EACE,sBAAA;ADtJN;ACyJI;EAVF;IAWI,eApOoB;ED8ExB;AACF;ACyJE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ADvJJ;ACyJI;EACE,sBAAA;ADvJN;AC0JI;EACE,WAAA;ADxJN;AC2JI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ADmMZ;;AC8JA;EACE,mBA1PO;AD+FT;AC6JE;EAHF;IAII,mBAAA;ED1JF;AACF;AC4JE;EACE,mBAAA;AD1JJ;AC6JE;EACE,aArQK;AD0GT;AC6JI;EAHF;IAII,aAAA;ED1JJ;AACF;AC4JI;EACE,aAAA;AD1JN;;AC+JA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AD5JF;AC8JE;EACE,eAAA;AD5JJ;AC+JE;EACE,sCAAA;AD7JJ;ACgKE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AD9JJ;;AC6KE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;AD1KJ;AC4KI;EACE,kBAAA;AD1KN;AC6KI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AD3KN;;ACgLA;EACE,8BAAA;AD7KF;;ACgLA;EACE,8BAAA;AD7KF;;ACgLA;EACE,+BAAA;AD7KF;;ACgLA;EACE,8BAAA;AD7KF;;ACgLA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AD7KF;AC+KE;EACE,2BAAA;EACA,mBAAA;AD7KJ;ACgLE;EACE,yBAzbiB;EA0bjB,WA1aO;AD4PX;ACiLE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AD/KJ;ACkLE;EACE,yBAjckB;EAkclB,cArciB;ADqRrB;ACmLE;EACE,yBAvbS;EAwbT,WA1bO;ADyQX;ACmLI;EACE,6BAAA;ADjLN;;ACsLA;EACE;IACE,uBAAA;EDnLF;ECsLA;IACE,yBAAA;EDpLF;AACF;ACuLA;EACE,8BAAA;ADrLF;;ACwLA;EACE,8BAAA;ADrLF;;ACwLA;EACE,+BAAA;ADrLF;;ACwLA;EACE,8BAAA;ADrLF;;ACwLA;EACE,qBAAA;ADrLF;;ACwLA;EACE,UAAA;ADrLF;ACuLE;EACE,qBAAA;ADrLJ;;ACyLA;EACE,UAAA;ADtLF;;AC0LE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ADxLJ;AC2LM;EACE,mBAAA;ADzLR;AC8LE;EACE,2BAAA;AD5LJ;AC+LE;EACE,uBAAA;AD7LJ;ACgME;EACE,mBAAA;AD9LJ;;ACmME;EACE,mBAAA;ADhMJ;ACmME;EACE,yBAAA;ADjMJ;ACoME;EACE,sBAAA;ADlMJ;ACqME;EACE,uBAAA;ADnMJ;ACsME;EACE,oBAAA;ADpMJ;;AA7YA,YAAA;AAcA;EACE,yBAda;AAiZf;;AAjYA;EACE,yBAhBU;AAoZZ;;AAlYA;EACE,yBAjBM;AAsZR;;AAnYA;EACE,yBAnBY;AAyZd;;AAnYA;EACE,yBApBK;AA0ZP;;AAnYA;EACE,yBAvBY;AA6Zd;;AAnYA;EACE,yBA7BI;AAmaN;;AAnYA;EACE,yBA7BS;AAmaX;;AAnYA,kBAAA;AAGE;EACE,4BC7CO;ED8CP,gBAAA;EACA,UAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EAkIA,0DAAA;EA0CA,gBAAA;EAkDA,WAAA;EAwMA,aAAA;EA6EA,UAAA;EASA,mBAAA;AAlHJ;AAxYI;EARF;IASI,WAAA;EA2YJ;AACF;AAzYI;EACE,cAAA;EACA,wBC7DK;ADwcX;AAxYI;EACE,wBCjEK;AD2cX;AAvYI;EACE,gBAAA;EACA,kBAAA;AAyYN;AAvYM;EAJF;IAKI,aAAA;EA0YN;AACF;AAxYM;EARF;IASI,aAAA;EA2YN;AACF;AAzYM;EACE,WCXW;ADsZnB;AAzYM;EACE,sBAAA;EACA,WAAA;AA2YR;AAxYI;EACE,4BCtFK;EDuFL,eAAA;EACA,0BAAA;EACA,iBAAA;EACA,eAAA;AA0YN;AAxYM;EAPF;IAQI,eAAA;EA2YN;AACF;AAzYI;EACE,4BCjGK;EDkGL,eAAA;EACA,iBAAA;EACA,SAAA;AA2YN;AAzYM;EANF;IAOI,eAAA;EA4YN;AACF;AA1YI;EACE,kBAAA;AA4YN;AA1YM;EAHF;IAII,aAAA;EA6YN;AACF;AA3YM;EAPF;IAQI,aAAA;EA8YN;AACF;AA5YI;EACE,uBAAA;EACA,mBAAA;AA8YN;AA5YM;EAJF;IAKI,aAAA;EA+YN;AACF;AA7YM;EARF;IASI,aAAA;EAgZN;AACF;AA9YM;EACE,YAAA;EACA,iBAAA;EACA,sBAAA;AAgZR;AA7YI;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kCAAA;EACA,wBAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;AA+YN;AA9YM;EACE,sBChFW;ADgenB;AA7YI;EACE,YAAA;EACA,mBAAA;AA+YN;AA9YM;EACE,WAAA;AAgZR;AA9YM;EACE,yBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;AAgZR;AA/YQ;EACE,6BAAA;AAiZV;AA7YI;EACE,mBAAA;AA+YN;AA5YI;EACE,kBAAA;EACA,iBAAA;AA8YN;AA7YM;EACE,eAAA;EACA,WAAA;EACA,WAAA;AA+YR;AAxYM;EACE,cAzLO;AAmkBf;AAvYM;EACE,yBAAA;EACA,kFAAA;AAyYR;AAvYM;EACE,yBAAA;AAyYR;AAxYQ;EACE,kFAAA;EACA,2BAAA;EACA,wBAAA;EACA,2BAAA;EACA,YAAA;EAGA,aAAA;EACA,eAAA;AA0YV;AAzYU;EACE,gBAAA;AA2YZ;AAzYU;EAGE,YAAA;AA2YZ;AAxYQ;EACE,cAtNK;EAuNL,eAAA;AA0YV;AAvYM;EACE,cA3NO;AAomBf;AAlYM;EACE,cAhOA;AAomBR;AAjYM;EACE,yBAAA;EACA,kFAAA;AAmYR;AAjYM;EACE,yBAAA;EACA,gBAAA;AAmYR;AAlYQ;EACE,kFAAA;EACA,2BAAA;EACA,wBAAA;EACA,2BAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;AAoYV;AAlYU;EATF;IAUI,WAAA;EAqYV;AACF;AApYU;EACE,gBAAA;AAsYZ;AApYU;EACE,wBAAA;AAsYZ;AApYU;EACE,2IAAA;EACA,iCAAA;EACA,iCAAA;EACA,qCAAA;EACA,iBAAA;AAsYZ;AAnYQ;EACE,cArQF;EAsQE,WAAA;AAqYV;AAlYM;EACE,cA1QA;AA8oBR;AA9XM;EACE,cA7QD;AA6oBP;AA7XM;EACE,yBAAA;EACA,kFAAA;AA+XR;AA9XQ;EACE,gBCvNS;ED6NT,kEAAA;EAEA,kCAAA;AA+XV;AA3XM;EACE,cAjSD;EAkSC,eAAA;AA6XR;AA1XM;EACE,YAAA;EACA,2BAAA;EACA,mBAAA;AA4XR;AA1XQ;EACE,UAAA;EACA,cA5SH;EA6SG,4BCnTC;AD+qBX;AA1XU;EALF;IAMI,iCAAA;EA6XV;AACF;AA3XU;EACE,eAAA;AA6XZ;AA1XU;EACE,eAAA;EACA,WAAA;EACA,4BAAA;EACA,kBAAA;EACA,4BClUD;EDmUC,wBAAA;AA4XZ;AA1XY;EARF;IASI,4BAAA;EA6XZ;AACF;AA3XY;EACE,WAAA;EACA,cAAA;EACA,4BC5UH;ED6UG,kBAAA;EACA,eAAA;EACA,cAAA;AA6Xd;AA1XY;EACE,YAAA;EACA,mBA9UP;EA+UO,WClRK;EDmRL,eAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,4BC3VH;ED4VG,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;AA4Xd;AA1Xc;EAfF;IAgBI,eAAA;IACA,YAAA;IACA,WAAA;IACA,kBAAA;EA6Xd;AACF;AA1XY;EACE,YAAA;AA4Xd;AAzXU;EACE,YAAA;AA2XZ;AAzXU;EACE,aAAA;AA2XZ;AAxXU;EACE,qBAAA;AA0XZ;AAvXU;EACE,yBAAA;EACA,aAAA;EACA,kBAAA;AAyXZ;AAvXU;EACE,yBAAA;EACA,YAAA;AAyXZ;AAxXY;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,SAAA;AA0Xd;AAxXY;EACE,YAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,wBAAA;AA0Xd;AAzXc;EACE,gBC1UG;ADqsBnB;AAxXY;EACE,YAAA;AA0Xd;AAvXc;EACE,iBAAA;AAyXhB;AAvXc;EACE,WAAA;AAyXhB;AAvXc;EACE,gBAAA;EACA,WAAA;EACA,iCAAA;AAyXhB;AAvXc;EACE,uBAAA;EACA,YAAA;EACA,gBAAA;AAyXhB;AAxXgB;EACE,YAAA;AA0XlB;AArXU;EACE,8BAAA;AAuXZ;AApXU;EACE,kBAAA;EACA,YAAA;EACA,OAAA;EACA,QAAA;EACA,kBAAA;AAsXZ;AAnXU;EACE,mBAAA;AAqXZ;AAlXU;EAGE,aAAA;EAGA,sBAAA;EACA,aAAA;AAoXZ;AAlXY;EAGE,OAAA;AAoXd;AA/WQ;EACE,kBAAA;AAiXV;AA7WM;EACE,cA1cD;AAyzBP;AA5WM;EACE,2BAAA;AA8WR;AAxWM;EACE,cAtdF;AAg0BN;AAvWM;EACE,cA1dF;AAm0BN;AAtWM;EACE,cA9dF;AAs0BN;AArWM;EACE,eAAA;EACA,4BCxeG;AD+0BX;AArWM;EACE,kBAAA;AAuWR;AArWM;EACE,yBAAA;EACA,kFAAA;AAuWR;AArWM;EACE,YAAA;EACA,yBAAA;EACA,mBAAA;AAuWR;AAtWQ;EACE,YAAA;AAwWV;AAvWU;EACE,mCAAA;AAyWZ;AArWQ;EACE,YAAA;EACA,+BAAA;AAuWV;AApWQ;EACE,cA7fJ;EA8fI,iBAAA;AAsWV;AApWQ;EACE,yBAjgBJ;EAkgBI,gBAAA;AAsWV;AArWU;EACE,WCtcO;EDucP,WAAA;EACA,kBAAA;EACA,iBAAA;AAuWZ;AApWQ;EACE,gBAAA;EACA,YAAA;AAsWV;AArWU;EACE,cA9gBN;EA+gBM,WAAA;EACA,gBAAA;AAuWZ;AArWU;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;AAuWZ;AAtWY;EACE,gBC3dK;ADm0BnB;AA9VQ;EACE,iBAAA;AAgWV;AA1VI;EACE,mBAAA;AA4VN;AA3VM;EACE,gBAAA;AA6VR;AA3VQ;EAHF;IAII,eAAA;EA8VR;AACF;AA5VM;EACE,kBAAA;AA8VR;AA7VQ;EACE,eAAA;EACA,gBAAA;AA+VV;AA7VU;EAJF;IAKI,eAAA;EAgWV;AACF;AA5VQ;EACE,eAAA;AA8VV;AAzVU;EAFF;IAGI,kBAAA;EA4VV;AACF;;AAtVA;EACI,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;AAyVJ;;AAtVA,qBAAA;AAEE;EACE,4BClmBO;EDmmBP,gBAAA;EACA,UAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;AAwVJ;AAvVI;EACE,kBAAA;AAyVN;AAvVI,2BAAA,+BAAA;EACE,+CAAA,EACA,oBAAA;EACA,qBAAA;EACA,YAAA;EAGA,eAAA;AAyVN;AAtVI;EACE,YAAA;AAwVN;AAtVI;EACE,sBAAA;EAGA,mBAAA;EAEA,aAAA;EACA,qBAAA;EAGA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,8BAAA;EACA,gBAAA;AAwVN;AAvVM;EACE,eAAA;AAyVR;AAvVM;EACE,yBAAA;EACA,eAAA;EACA,4BC9oBG;ADu+BX;AAxVQ;EACE,kBAAA;AA0VV;AAtVI;EACE,sBAAA;EACA,kBAAA;AAwVN;AAtVI;EACE,sBAAA;EACA,oBAAA;AAwVN;AArVI;EAGE,aAAA;EACA,yBAAA;EACA,YAAA;AAuVN;AAtVM;EACE,WAAA;EACA,iBAAA;AAwVR;AAtVM;EAGE,YAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;AAwVR;AAvVQ;EACE,gBC7mBS;ADs8BnB;AAtVM;EACE,YAAA;AAwVR;;AAjVA;EACE,aAAA;AAoVF;;AAjVA;EACE,cAAA;AAoVF;;AAjVA;EACE,oCAAA;AAoVF","sourcesContent":["/* Style-for-innovation-page*/\n@import './../../../assets/styles/variables';\n\n/*Variables*/\n$clarify-color:#00aed9;\n$light-blue:#e2f3fa;\n\n$orange:#f68c1f;\n$light-orange:#fdf1e1;\n\n$pink:#ef465b;\n$green:#66bd4a;\n$light-green: #eef6ea;\n\n$dark-grey:#6e6d72;\n\n\n::ng-deep .sky-bg {\n  background-color:$clarify-color;\n}\n::ng-deep .sky-light-bg {\n  background-color:$light-blue;\n}\n::ng-deep .orange-bg {\n  background-color:$orange;\n}\n::ng-deep .orange-light-bg {\n  background-color:$light-orange;\n}\n\n::ng-deep .develop-bg{\n  background-color: $green;\n}\n\n::ng-deep .develop-light-bg{\n  background-color: $light-green;\n}\n\n::ng-deep .implement-bg{\n  background-color: $pink;\n}\n\n::ng-deep .notes-bg {\n  background-color:$dark-grey;\n}\n\n/* Common-classes*/\n\n::ng-deep .all-toolcards {\n  ::ng-deep.innovation-section {\n    font-family: $muso-500;\n    max-width: 960px;\n    width: 90%;\n    margin: 20px auto 30px;\n    background: #fefefe;\n    overflow: hidden;\n\n    @media #{$mobile} {\n      width: 100%;\n    }\n\n    p {\n      color: #8a8a8a;\n      font-family: $muso-100;\n    }\n\n    li {\n      font-family: $muso-100;\n    }\n\n    .section-top {\n      overflow: hidden;\n      padding: 30px 60px;\n\n      @media #{$tablet} {\n        padding: 30px;\n      }\n\n      @media #{$mobile} {\n        padding: 20px;\n      }\n\n      .top-heading {\n        color: $color-light-type;\n      }\n      .sub-heading {\n        color: $color-light-type !important;\n        margin: 0px;\n      }\n    }\n    .top-heading {\n      font-family: $muso-500;\n      font-size: 50px;\n      text-transform: capitalize;\n      line-height: 52px;\n      margin-top: 0px;\n\n      @media #{$mobile} {\n        font-size: 36px;\n      }\n    }\n    .sub-heading {\n      font-family: $muso-500;\n      font-size: 24px;\n      line-height: 30px;\n      margin: 0;\n\n      @media #{$mobile} {\n        font-size: 20px;\n      }\n    }\n    .shaded-part {\n      padding: 30px 60px;\n\n      @media #{$tablet} {\n        padding: 30px;\n      }\n\n      @media #{$mobile} {\n        padding: 20px;\n      }\n    }\n    .content-part {\n      padding: 30px 60px 30px;\n      margin-bottom: 35px;\n\n      @media #{$tablet} {\n        padding: 30px;\n      }\n\n      @media #{$mobile} {\n        padding: 20px;\n      }\n\n      textarea.no-brdr {\n        border: none;\n        min-height: 200px;\n        background-image: none;\n      }\n    }\n    textarea {\n      width: 100%;\n      border: none;\n      min-height: 60px;\n      padding: 10px 5px;\n      background-color: #f1f3fe;\n      background-position: center center;\n      background-size: 8px 1px;\n      background-repeat: repeat-x;\n      outline: none;\n      margin-bottom: 15px;\n      &:focus {\n        background-color: $color-light-type;\n      }\n    }\n    form.input-form {\n      padding: 2px;\n      margin-bottom: 15px;\n      label {\n        margin: 0px;\n      }\n      input {\n        background-color: #f1f3fe;\n        border: none;\n        outline: none;\n        padding: 5px 0px;\n        &:focus {\n          background-color: transparent;\n        }\n      }\n    }\n    .clr {\n      margin-bottom: 30px;\n    }\n\n    .innovation-footer {\n      text-align: center;\n      padding: 15px 0px;\n      p {\n        font-size: 10px;\n        color: #333;\n        margin: 0px;\n      }\n    }\n\n    /* use-custom-classes for various section with same style*/\n\n    &.clarify {\n      .sub-heading {\n        color: $clarify-color;\n\n      }\n      textarea {\n        border: 1px solid $clarify-color;\n        background-image: linear-gradient(to left, #00aed9 33%, rgba(255, 255, 255, 0) 0%);\n      }\n      form.input-form {\n        border: 2px solid $clarify-color;\n        .input-tabs {\n          background-image: linear-gradient(to left, #00aed9 33%, rgba(255, 255, 255, 0) 0%);\n          background-position: bottom;\n          background-size: 8px 1px;\n          background-repeat: repeat-x;\n          padding: 1px;\n          display: -ms-flexbox;\n          display: -webkit-flex;\n          display: flex;\n          flex-wrap: wrap;\n          &:last-child {\n            background: none;\n          }\n          input {\n            -ms-flex-positive: 1;\n            -webkit-flex-grow: 1;\n            flex-grow: 1;\n          }\n        }\n        label {\n          color: $clarify-color;\n          min-width: 18px;\n        }\n      }\n      .clr {\n        color: $clarify-color;\n      }\n    }\n\n    /* Orange-color*/\n\n    &.ideate {\n      .sub-heading {\n        color: $orange;\n\n      }\n      textarea {\n        border: 1px solid $orange;\n        background-image: linear-gradient(to left, #f68c1f 33%, rgba(255, 255, 255, 0) 0%);\n      }\n      form.input-form {\n        border: 2px solid $orange;\n        overflow: hidden;\n        .input-tabs {\n          background-image: linear-gradient(to left, #f68c1f 33%, rgba(255, 255, 255, 0) 0%);\n          background-position: bottom;\n          background-size: 8px 1px;\n          background-repeat: repeat-x;\n          padding: 1px;\n          width: 50%;\n          float: left;\n\n          @media #{$mobile} {\n            width: 100%;\n          }\n          &:last-child {\n            background: none;\n          }\n          input {\n            width: calc(100% - 22px);\n          }\n          &:nth-child(even) {\n            background-image: linear-gradient(to left, #f68c1f 33%, rgba(255, 255, 255, 0) 0%), linear-gradient(#f68c1f 33%, rgba(255, 255, 255, 0) 0%);\n            background-position: bottom, left;\n            background-size: 8px 1px, 1px 8px;\n            background-repeat: repeat-x, repeat-y;\n            padding-left: 5px;\n          }\n        }\n        label {\n          color: $orange;\n          width: 18px;\n        }\n      }\n      .clr {\n        color: $orange;\n      }\n    }\n\n    /* Develop*/\n    &.develop {\n      .sub-heading, .develop-color {\n        color: $green;\n      }\n\n      textarea {\n        border: 1px solid $green;\n        background-image: linear-gradient(to left, $green 20%, rgba(255, 255, 255, 0) 0%);\n        &.line-text {\n          background: $color-light-type;\n          background: -webkit-gradient(linear, 0 0, 0 100%, from(#66bd4a), color-stop(4%, $color-light-type)) 0 -8px;\n          background: -webkit-linear-gradient(to bottom, #66bd4a 0%, $color-light-type 2%) 0 -8px;\n          background: -moz-linear-gradient(to bottom, #66bd4a 0%, $color-light-type 2%) 0 -8px;\n          background: -ms-linear-gradient(to bottom, #66bd4a 0%, $color-light-type 2%) 0 -8px;\n          background: -o-linear-gradient(to bottom, #66bd4a 0%, $color-light-type 2%) 0 -8px;\n          background: linear-gradient(to bottom, #66bd4a 0%, $color-light-type 2%) 0 -8px;\n\n          -webkit-background-size: 100% 35px;\n        }\n      }\n\n      strong {\n        color: $green;\n        font-size: 110%;\n      }\n\n      .point-evaluation {\n        padding: 0px;\n        border: 1.5px solid $green;\n        margin-bottom: 20px;\n\n        .f-col-4 {  \n          padding: 0;\n          color: $green;\n          font-family: $muso-500;\n          \n          @media #{$mobile-up} {\n            border-right: 1.5px solid $green;\n          }\n          \n          &:last-child {\n            border-right: 0;\n          }\n\n          h4 {\n            font-size: 18px;\n            margin: 0px;\n            padding: 15px 15px 13px 50px;\n            position: relative;\n            font-family: $muso-500;\n            border-bottom: 1px solid;\n\n            @media #{$mobile} {\n              padding: 15px 15px 13px 40px;\n            }\n\n            small {\n              clear: both;\n              display: block;\n              font-family: $muso-500;\n              line-height: 1.4em;\n              margin-top: 4px;\n              color: inherit;\n            }\n\n            &:before {\n              content: \"P\";\n              background: $green;\n              color: $color-light-type;\n              font-size: 20px;\n              height: 35px;\n              width: 35px;\n              position: absolute;\n              border-radius: 17.5px;\n              font-family: $muso-500;\n              text-align: center;\n              vertical-align: middle;\n              padding-top: 7px;\n              margin-left: -42px;\n\n              @media #{$mobile} {\n                font-size: 13px;\n                height: 20px;\n                width: 25px;\n                margin-left: -35px;\n              }\n            }\n\n            &.middle-header:before {\n              content: \"O\";\n            }\n          }\n          &.issues h4:before {\n            content: \"I\";\n          }\n          &.new-thinking h4:before {\n            content: \"Nt\";\n          }\n\n          .middle-header {\n            border-top: 1px solid;\n          }\n\n          .fill-text {\n            border-bottom: 1px dashed;\n            padding: 15px;\n            position: relative;\n          }\n          .fill-input {\n            border-bottom: 1px dashed;\n            padding: 1px;\n            label {\n              min-width: 20px;\n              line-height: 40px;\n              text-align: center;\n              margin: 0;\n            }\n            input {\n              border: none;\n              outline: none;\n              min-height: 42px;\n              background: #f1f3fe;\n              width: calc(100% - 24px);\n              &:focus {\n                background: $color-light-type;\n              }\n            }\n            &:last-child {\n              border: none;\n            }\n            &.mid {\n              label {\n                line-height: 20px;\n              }\n              input {\n                width: 100%;\n              }\n              textarea {\n                min-height: 69px;\n                margin: 0px;\n                border-bottom: 1px dashed #66bd4a;\n              }\n              &.last {\n                border: none !important;\n                height: 100%;\n                overflow: hidden;\n                textarea {\n                  height: 100%;\n                }\n              }\n            }\n          }\n          &.pluses .fill-input:nth-of-type(3) {\n            border-bottom: none !important;\n          }\n\n          .fill-bottom {\n            position: absolute;\n            bottom: 10px;\n            left: 0;\n            right: 0;\n            text-align: center;\n          }\n\n          .fill-text:last-child, .last-cell {\n            border-bottom: none;\n          }\n\n          .fill-wrapper {\n            display: -ms-flexbox;\n            display: -webkit-flex;\n            display: flex;\n            -ms-flex-direction: column;\n            -webkit-flex-direction: column;\n            flex-direction: column;\n            height: 364px;\n\n            .fill-text {\n              -ms-flex: 1;\n              -webkit-flex: 1;\n              flex: 1;\n            }\n          }\n        }\n\n        .col-sm-4:last-child {\n          border-right: none;\n        }\n      }\n\n      .clr {\n        color: $green;\n      }\n\n      .shaded-part.footer-page {\n        padding-top: 0px !important;\n      }\n    }\n\n    /* Implement*/\n    &.implement {\n      .sub-heading {\n        color: $pink;\n      }\n\n      .clr {\n        color: $pink;\n      }\n\n      .implement-color {\n        color: $pink;\n      }\n\n      h4 {\n        font-size: 18px;\n        font-family: $muso-500;\n      }\n      ul {\n        padding-left: 15px;\n      }\n      textarea {\n        border: 1px solid $pink;\n        background-image: linear-gradient(to left, $pink 20%, rgba(255, 255, 255, 0) 0%);\n      }\n      .to-do {\n        padding: 0px;\n        border: 1px solid $pink;\n        margin-bottom: 15px;\n        .col-sm-6 {\n          padding: 0px;\n          input {\n            width: calc(100% - 18px) !important;\n          }\n\n        }\n        .col-sm-2 {\n          padding: 0px;\n          border-left: 1px dotted $pink;\n        }\n\n        .to-do-heading {\n          color: $pink;\n          padding: 5px 10px;\n        }\n        .to-do-term {\n          background-color: $pink;\n          min-height: 30px;\n          p {\n            color: $color-light-type;\n            margin: 0px;\n            padding-left: 10px;\n            line-height: 30px;\n          }\n        }\n        .to-do-input {\n          min-height: 42px;\n          padding: 2px;\n          label {\n            color: $pink;\n            width: 12px;\n            font-weight: 100;\n          }\n          input {\n            outline: none;\n            background: #f1f3fe;\n            min-height: 40px;\n            width: 100%;\n            border: none;\n            &:focus {\n              background: $color-light-type;\n            }\n          }\n        }\n      }\n    }\n\n    /* Notes */\n    &.notes {\n      .content-part {\n        textarea {\n          min-height: 800px;\n        }\n      }\n    }\n\n    /* Welcome-section*/\n    &.welcome {\n      background: #e7e7e7;\n      .top-heading img {\n        max-width: 300px;\n\n        @media #{$mobile} {\n          max-width: 100%;\n        }\n      }\n      .shaded-part {\n        text-align: center;\n        span {\n          font-size: 20px;\n          font-weight: 100;\n\n          @media #{$mobile} {\n            font-size: 16px;\n          }\n        }\n      }\n      .content-part {\n        p, ul {\n          font-size: 18px;\n        }\n\n        ul {\n\n          @media #{$mobile} {\n            padding-left: 22px;\n          }\n        }\n      }\n    }\n  }\n}\n::ng-deep ul.nav-wizard{\n    background-color: #f9f9f9;\n    border: 1px solid #d4d4d4;\n    border-radius: 6px;\n    position: relative;\n    overflow: hidden;\n    display: table;\n    float: none;\n    margin-left: auto;\n    margin-right: auto;\n    max-width: 960px;\n}\n\n/* Eos-Section-Style*/\n.all-toolcards {\n  .eos {\n    font-family: $muso-500;\n    max-width: 960px;\n    width: 90%;\n    margin: 20px auto 30px;\n    background: #fefefe;\n    overflow: hidden;\n    border: 1px solid $border-color;\n    ul {\n      padding-left: 15px;\n    }\n    .row { /* OLD - iOS 6-, Safari 3.1-6 */\n      /* OLD - Firefox 19- (buggy but mostly works) */\n      display: -ms-flexbox; /* TWEENER - IE 10 */\n      display: -webkit-flex;\n      padding: 1px;\n      -ms-flex-wrap: wrap;\n      -webkit-flex-wrap: wrap;\n      flex-wrap: wrap;\n    }\n\n    .eos-right {\n      padding: 0px;\n    }\n    .eos-heading {\n      border: 1px solid $border-color;\n      -ms-flex-align: center;\n      -webkit-align-items: center;\n      align-items: center;\n      display: -ms-flexbox;\n      display: flex;\n      display: -webkit-flex;\n      -ms-flex-pack: center;\n      -webkit-justify-content: center;\n      justify-content: center;\n      background: #fafafb;\n      color: #706a6c;\n      border-left: 3px solid #1ab394;\n      padding: 8px 0px;\n      &:hover {\n        cursor: pointer;\n      }\n      h4 {\n        text-transform: uppercase;\n        font-size: 18px;\n        font-family: $muso-500;\n        sup {\n          font-family: arial;\n        }\n      }\n    }\n    .eos-content {\n      border: 1px solid $border-color;\n      padding: 11px 15px;\n    }\n    .eos-right-content {\n      border: 1px solid $border-color;\n      padding: 13px 15px 0;\n    }\n\n    .eos-input {\n      display: -webkit-flex;\n      display: -ms-flexbox;\n      display: flex;\n      border-bottom: 1px dotted;\n      padding: 1px;\n      label {\n        margin: 0px;\n        line-height: 30px;\n      }\n      input {\n        -webkit-flex-grow: 1;\n        -ms-flex-positive: 1;\n        flex-grow: 1;\n        border: none;\n        outline: none;\n        background: #f1f3fe;\n        min-height: 30px;\n        &:focus {\n          background: $color-light-type;\n        }\n      }\n      &:last-child {\n        border: none;\n      }\n    }\n  }\n}\n\n// Transcripts\n::ng-deep .audio-modal a, ::ng-deep .audio-modal p{\n  display: none;\n}\n\n::ng-deep .audio-modal .showText{\n  display: block;\n}\n\n::ng-deep.grey{\n  background: rgba(236, 236, 236, 0.9);\n}\n\n","// Font\n$font-stack: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$muso-100: \"Museo-100\";\n$muso-300: \"Museo-300\";\n$muso-300-i: \"Museo-300Italic\";\n$muso-500: \"Museo-regular\";\n$muso-700: \"Museo-700\";\n$muso-700-i: \"Museo-700Italic\";\n$muso-sans: \"MuseoSans-300\";\n$car-font: \"Marydale\";\n$car-big-font: \"Bangers\", cursive;\n$font-museo: \"Conv_museo-500-webfont\";\n$font-helvetica: \"Helvetica\", \"open sans\";\n$MuseoSansCondensed-300: \"MuseoSansCondensed-300\";\n\n$fwBold: 700;\n\n//Foursight\n// $clarify-color: #06A6CE;\n// $ideate-color: #FF8300;\n// $develop-color: #7BBC43;\n// $implement-color: #FF485C;\n$clarify-color: rgba(0, 173, 208, 1);\n$ideate-color: rgba(255, 121, 0, 1);\n$develop-color: rgba(105, 190, 40, 1);\n$implement-color: rgba(245, 67, 89, 1);\n$low-clarify-color: rgba(0, 173, 208, 1);\n$low-ideate-color: rgba(255, 121, 0, 1);\n$low-develop-color: rgba(105, 190, 40, 1);\n$low-implement-color: rgba(245, 67, 89, 1);\n$profile-connector-color: #656668;\n// Profile Neutral color\n$integrator-color: #e3e3e3;\n// Team Report\n$report-integrator: #a7a7a7;\n// Body text color in reports\n$body-content-color: #676a6c;\n// Learner Map\n$gray-lm: rgba(0, 0, 0, 0.2);\n$border-color: #aaa;\n\n$color-neutral-dark: #6d6e71;\n$color-neutral-dark-500: #6a6a6a;\n$color-neutral-mid: #ccc;\n$color-neutral-light: #f1f1f2;\n$color-neutral-mid-old: #9e9e97;\n$color-dark-green: #4cae4c;\n$color-light-grey: #d9d9d9;\n$color-red: #ff485c;\n\n$color-grey-1: #e7eaec;\n\n$clrGray1: #f6f6f6;\n\n$clrDarkGray1: #ddd;\n\n$clrGrey: #eee;\n$clrWhite: #fff;\n$clrBlack: #000;\n$clrWarning: #f8ac59;\n\n$assets: \"https://assets.foursightonline.com/app\";\n$adminUpload: \"https://assets.foursightonline.com/admin-uploads/docs/\";\n\n$separator: \"\\//\";\n\n$active-class: #017ebc;\n\n// anchor Tag\n$anchor-color: #337ab7;\n\n//Sidebar\n$color-light-type: #fff;\n// submenu background\n$fs-dark-grey: #464646;\n// Hover\n$fs-active-light: #5f5f63;\n$fs-sidenav-bg: #333333;\n$fs-sidenav-hov-bg: #3e3e3f;\n$fs-green: #69be28;\n\n$clrInputAccent: #639935;\n\n$fn-fs-h1: 44px;\n$fn-fs-h1-mobile: 38px;\n$fn-lh-h1: 1.1;\n\n$fn-fs-h2: 38px;\n$fn-fs-h2-mobile: 32px;\n$fn-lh-h2: 1.2;\n\n$fn-fs-h3: 32px;\n$fn-fs-h3-mobile: 24px;\n$fn-lh-h3: 1.2;\n\n$fn-fs-h4: 24px;\n$fn-fs-h4-mobile: 20px;\n$fn-lh-h4: 1.2;\n\n$fn-fs-h5: 18px;\n$fn-lh-h5: 1.2;\n\n$fn-fs-h6: 16px;\n$fn-lh-h6: 1.3;\n\n$fn-title-subtext: 22px;\n$fn-title-subtext-mobile: 18px;\n\n$pageWidth: 1080px;\n$pageWidthSmall: 820px;\n$pageWidthFluid: 1200px;\n\n$secPad: 60px;\n\n$pageWidth: 1080px;\n$pageWidthFluid: 1200px;\n\n$desktop: \"only screen and (max-width: 1600px)\";\n$mac: \"only screen and (max-width: 1350px)\";\n$pc-up: \"only screen and (min-width: 1200px)\";\n$pc: \"only screen and (max-width: 1199px)\";\n$tablet-up: \"only screen and (min-width: 992px)\";\n$tablet: \"only screen and (max-width: 991px)\";\n$mobile-up: \"only screen and (min-width: 768px)\";\n$mobile: \"only screen and (max-width: 767px)\";\n$xl: \"only screen and (max-width: 1440px)\";\n$xl-up: \"only screen and (min-width: 1440px)\";\n\nimg {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n@mixin headingfont() {\n  font-family: $muso-700 !important;\n  font-weight: normal !important;\n}\n\n@mixin contentfont() {\n  font-family: $muso-300 !important;\n  font-weight: normal !important;\n}\n\n.fn-body {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    --hGap: 10px;\n    font-family: $muso-700;\n    color: $color-neutral-dark;\n    margin-bottom: var(--hGap);\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1,\n  .h1-text {\n    font-size: $fn-fs-h1;\n    line-height: $fn-lh-h1;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h1-mobile;\n    }\n  }\n\n  h2,\n  .h2-text {\n    font-size: $fn-fs-h2;\n    line-height: $fn-lh-h2;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h2-mobile;\n    }\n  }\n\n  h3,\n  .h3-text {\n    font-size: $fn-fs-h3;\n    line-height: $fn-lh-h3;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h3-mobile;\n    }\n  }\n\n  h4,\n  .h4-text {\n    font-size: $fn-fs-h4;\n    line-height: $fn-lh-h4;\n  }\n\n  h5,\n  .h5-text {\n    font-size: $fn-fs-h5;\n    line-height: $fn-lh-h5;\n  }\n\n  h6,\n  .h6-text {\n    font-size: $fn-fs-h6;\n    line-height: $fn-lh-h6;\n  }\n\n  $fn-title-subtext: 22px;\n  $fn-title-subtext-mobile: 18px;\n\n  p {\n    font-size: 18px;\n    line-height: 1.6;\n    color: $color-neutral-dark-500;\n    margin-top: 0;\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media #{$mobile} {\n      font-size: 16px;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n\n  sup {\n    font-size: 0.7em;\n    position: relative;\n    top: 5px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.bg-grey {\n  background-color: $clrGrey;\n}\n\n.fn-container {\n  max-width: $pageWidth;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n\n  @media #{$tablet-up} {\n    margin-left: 0;\n  }\n\n  &--fluid {\n    max-width: $pageWidthFluid;\n  }\n\n  &--small {\n    max-width: $pageWidthSmall;\n    width: 100%;\n  }\n}\n\n.text {\n  &-center {\n    text-align: center;\n  }\n\n  &-right {\n    text-align: right;\n  }\n}\n\n.d {\n  &-none {\n    display: none;\n  }\n}\n\n.section-title {\n  text-align: center;\n\n  &:not(:last-child) {\n    margin-bottom: calc($secPad - 20px);\n  }\n\n  h2 {\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n  }\n\n  p {\n    max-width: 900px;\n    width: 100%;\n    margin-inline: auto;\n    font-size: $fn-title-subtext;\n\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n\n    @media #{$mobile} {\n      font-size: $fn-title-subtext-mobile;\n    }\n  }\n\n  .section-title__linkcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    &:not(:last-child) {\n      margin-block-end: 20px;\n    }\n\n    & > * {\n      margin: 5px;\n    }\n\n    .fn-btn {\n      padding-block: 6px;\n      padding-inline: 13px;\n      font-size: 12px;\n      font-family: $muso-sans;\n    }\n  }\n}\n\n.section-padding {\n  padding-block: $secPad;\n\n  @media #{$mobile} {\n    padding-block: ($secPad - 20px);\n  }\n\n  &-small {\n    padding-block: calc($secPad / 2);\n  }\n\n  &-all {\n    padding: $secPad;\n\n    @media #{$mobile} {\n      padding: calc($secPad / 2);\n    }\n\n    &-small {\n      padding: calc($secPad / 2);\n    }\n  }\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n\n  &--small-border {\n    --lineSize: 6px;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: calc(var(--hGap) * 2.5);\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--lineSize);\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%,\n      $clarify-color 25%,\n      $ideate-color 25%,\n      $ideate-color 50%,\n      $develop-color 50%,\n      $develop-color 75%,\n      $implement-color 75%,\n      $implement-color 100%\n    );\n  }\n}\n\n.custom-list {\n  li {\n    font-size: 18px;\n    line-height: 1.4;\n    color: $color-neutral-dark-500;\n    list-style: none;\n    position: relative;\n    padding-left: 15px;\n\n    &:not(:last-child) {\n      margin-bottom: 4px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 10px;\n      left: 0;\n      width: 3px;\n      height: 3px;\n      background-color: var(--clrProfile);\n    }\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: $develop-color;\n  color: $clrWhite;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: $muso-700;\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n\n  &:focus {\n    outline: 1px dashed $color-neutral-dark-500;\n    outline-offset: 4px;\n  }\n\n  &:hover {\n    background-color: $color-neutral-dark;\n    color: $clrWhite;\n  }\n\n  &--sm {\n    font-size: 14px;\n    padding-block: 10px;\n    padding-inline: 20px;\n  }\n\n  &--grey {\n    background-color: $color-neutral-light;\n    color: $color-neutral-dark;\n  }\n\n  &--ongoing {\n    background-color: $clrWarning;\n    color: $clrWhite;\n\n    i {\n      animation: spin 0.3s infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.w-4 {\n  width: calc(100% / 3);\n}\n\n.w-3 {\n  width: calc(100% / 4);\n\n  &--wd {\n    width: calc(100% / 3);\n  }\n}\n\n.w-6 {\n  width: calc(100% / 2);\n}\n\n.fn {\n  &-row {\n    --rGap: 15px;\n    --rGap-minus: calc(-1 * var(--rGap));\n\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: var(--rGap-minus);\n\n    &--col-gap-exist {\n      .fn-col {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  &-col {\n    padding-inline: var(--rGap);\n  }\n\n  &-justify-center {\n    justify-content: center;\n  }\n\n  &-items-center {\n    align-items: center;\n  }\n}\n\n.m {\n  &x-auto {\n    margin-inline: auto;\n  }\n\n  &l-auto {\n    margin-inline-start: auto;\n  }\n\n  &l-0 {\n    margin-inline-start: 0;\n  }\n\n  &r-auto {\n    margin-inline-end: auto;\n  }\n\n  &r-0 {\n    margin-inline-end: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
